export const LIST_CAMPAIGN_REQUEST = 'LIST_CAMPAIGN_REQUEST';
export const LIST_CAMPAIGN_SUCCESS = 'LIST_CAMPAIGN_SUCCESS';
export const LIST_CAMPAIGN_FAIL = 'LIST_CAMPAIGN_FAIL';
export const LIST_CAMPAIGN_RESET = 'LIST_CAMPAIGN_RESET';

export const SEND_NEWSLETTER_CAMPAIGN_REQUEST = 'SEND_NEWSLETTER_CAMPAIGN_REQUEST';
export const SEND_NEWSLETTER_CAMPAIGN_SUCCESS = 'SEND_NEWSLETTER_CAMPAIGN_SUCCESS';
export const SEND_NEWSLETTER_CAMPAIGN_FAIL = 'SEND_NEWSLETTER_CAMPAIGN_FAIL';
export const SEND_NEWSLETTER_CAMPAIGN_RESET = 'SEND_NEWSLETTER_CAMPAIGN_RESET';

export const FORCE_SEND_CAMPAIGN_REQUEST = 'FORCE_SEND_CAMPAIGN_REQUEST';
export const FORCE_SEND_CAMPAIGN_SUCCESS = 'FORCE_SEND_CAMPAIGN_SUCCESS';
export const FORCE_SEND_CAMPAIGN_FAIL = 'FORCE_SEND_CAMPAIGN_FAIL';
export const FORCE_SEND_CAMPAIGN_RESET = 'FORCE_SEND_CAMPAIGN_RESET';